import styled from "styled-components";
import Tabela2 from "../Tabela2";
import { IoIosArrowForward } from "react-icons/io";
import { SkeletonLine } from "../SkeletonLine";
import DataTable from "../DataTable";

const PaginatedTableContainer = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 15px;
    box-sizing: border-box;
    gap: 10px;
`
const TableWrapper = styled.div`
    flex: 1;
    width: 100%;
    overflow: auto;
    border: 1px solid #ddd;
    background-color: #f3f3f3;
    border-radius: 8px;
    
    /* Estilos do scrollbar */
    &::-webkit-scrollbar {
        height: 8px;
        width: 12px;
        background-color: #f0f0f0;
    }
    
    &::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border-radius: 4px;
        border: 3px solid #f0f0f0;
    }
`
const FooterWrapper = styled.div`
    width: 100%;
    height: 40px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
`
const PaginationWrapper = styled.div`
    height: 30px;
    margin-left: auto;
    border: 1.2px solid #d3d3d3;
    border-radius: 4px;
    display: flex;
    box-sizing: border-box;
`
const ChangePageBtn = styled.div`
    width: 30px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color .3s;
    &:hover {
        background-color: #f0f0f0;
    }
`
const ChangePageIcon = styled(IoIosArrowForward)`
    width: 20px;
    height: 20px;
    color: #333;
    transform: ${({ direction }) => direction === 'prev' ? 'rotate(180deg)' : 'none'};
`
const PageNumber = styled.div`
    height: 100%;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1.2px solid #d3d3d3;
    border-right: 1.2px solid #d3d3d3;
    box-sizing: border-box;
    font-size: 16px;
    & p{
        margin: 0;
        color: #333;
    }
`
const TotalItems = styled.div`
    margin-left: 15px;
    font-size: 14px;
    color: #333;
    & p{
        margin: 0;
    }
`
const TotalPages = styled.div`
    margin-left: 15px;
    font-size: 14px;
    color: #333;
    & p{
        margin: 0;
    }
`

const PaginatedTable = ({ pagina, setPagina, children, thead, loading, colunas = 4, totalItems = 0, totalPages = 0 }) => {

    const nextPage = () => {
        setPagina(pagina + 1);
    }

    const prevPage = () => {
        if (pagina > 1) {
            setPagina(pagina - 1);
        }
    }

    return (
        <>
            <PaginatedTableContainer>
                <TableWrapper>
                    <DataTable>
                        <thead>
                            {thead}
                        </thead>
                        {
                            loading ? (
                                <>
                                    <tbody>
                                        {[...Array(50)].map((_, index) => (
                                            <tr key={index}>
                                                {[...Array(colunas)].map((_, colIndex) => (
                                                    <td key={colIndex}>
                                                        <SkeletonLine />
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </>
                            ) : (
                                children
                            )
                        }
                    </DataTable>
                </TableWrapper>
                <FooterWrapper>
                    {
                        //Colocar total de itens retornados pela API e total de páginas, caso a API retorne essa informação
                    }
                    <TotalItems>
                        <p>Total de itens: {totalItems}</p>
                    </TotalItems>
                    <TotalPages>
                        <p>Página {pagina} de {totalPages}</p>
                    </TotalPages>
                    <PaginationWrapper>
                        <ChangePageBtn onClick={prevPage}>
                            <ChangePageIcon direction="prev" />
                        </ChangePageBtn>
                        <PageNumber>{pagina}</PageNumber>
                        <ChangePageBtn onClick={nextPage}>
                            <ChangePageIcon direction="next" />
                        </ChangePageBtn>
                    </PaginationWrapper>
                </FooterWrapper>

            </PaginatedTableContainer>
        </>
    )
}

export default PaginatedTable;